
import { generateSecureToken } from './security';

// CSRF token management
export class CSRFProtection {
  private static readonly TOKEN_HEADER = 'X-CSRF-Token';
  private static readonly TOKEN_KEY = 'csrf_token';
  
  // Generate and store CSRF token
  static generateToken(): string {
    const token = generateSecureToken();
    if (typeof sessionStorage !== 'undefined') {
      sessionStorage.setItem(this.TOKEN_KEY, token);
    }
    return token;
  }
  
  // Get stored CSRF token
  static getToken(): string | null {
    if (typeof sessionStorage === 'undefined') return null;
    return sessionStorage.getItem(this.TOKEN_KEY);
  }
  
  // Validate CSRF token
  static validateToken(providedToken: string): boolean {
    const storedToken = this.getToken();
    return storedToken !== null && storedToken === providedToken;
  }
  
  // Add CSRF token to headers
  static addTokenToHeaders(headers: HeadersInit = {}): HeadersInit {
    const token = this.getToken();
    if (token) {
      return {
        ...headers,
        [this.TOKEN_HEADER]: token
      };
    }
    return headers;
  }
  
  // Clear CSRF token
  static clearToken(): void {
    if (typeof sessionStorage !== 'undefined') {
      sessionStorage.removeItem(this.TOKEN_KEY);
    }
  }
}

// Origin validation
export const validateOrigin = (origin: string | null): boolean => {
  if (!origin) return false;
  
  const allowedOrigins = [
    'https://lainasampo.fi',
    'https://www.lainasampo.fi',
    'http://localhost:3000',
    'http://localhost:5173',
    'https://lovable.dev'
  ];
  
  return allowedOrigins.includes(origin);
};
